import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getCustomerDetailState = (state: AppState) => state.contactsAndOrganizations.customers.customerDetail;

// Add other valid states here
export const customerDetailIsValidSelector = createSelector(
    getCustomerDetailState,
    state => state.overview.isValid && state.conditions.isValid && state.supplierExternalCustomerMappings.isValid
);
export const customerDetailMemberSelector = createSelector(getCustomerDetailState, state => ({
    isMember: state.global.isMember,
    memberSince: state.global.memberSince,
}));
